// extracted by mini-css-extract-plugin
export default {"mCard":"YA-z","image":"ZA-z","imageNoBackground":"_A-z","imageHasCategory":"aB-z","fullWidth":"bB-z"};